import { isSupportedConvertImageFile } from '../convert/convertImageEngine';
import {
    createPdfFromFiles,
    DEFAULT_CREATE_PDF_SETTINGS,
    PAGE_SIZE_OPTIONS,
    ORIENTATION_OPTIONS,
    MARGIN_OPTIONS,
    IMAGE_FIT_OPTIONS,
} from '../../pdf/create/createPdfEngine';

export { formatFileSize } from '../compress/compressImageEngine';

export const isSupportedToPdfImageFile = isSupportedConvertImageFile;
export { DEFAULT_CREATE_PDF_SETTINGS };
export { PAGE_SIZE_OPTIONS, ORIENTATION_OPTIONS, MARGIN_OPTIONS, IMAGE_FIT_OPTIONS };

/**
 * Build a PDF from image files in order, using the same settings as `pdf/create`.
 * @param {File[]} files
 * @param {object} options createPdfEngine settings
 * @param {(fileIndex: number, fileTotal: number) => void} [onProgress]
 */
export async function createPdfFromImages(files, options = {}, onProgress) {
    // `createPdfFromFiles` supports images (kind: 'image') via expandFileToPages().
    // It also applies orientation, margin, page numbers, image fit/quality, and effects.
    return createPdfFromFiles(files, options, onProgress);
}

export function defaultPdfName(files) {
    if (!files?.length) return 'images.pdf';
    const base = files[0].name.replace(/\.[^.]+$/, '');
    return files.length === 1 ? `${base}.pdf` : `${base}-and-more.pdf`;
}
